import { Package } from 'lucide-react'

interface ProductProps {
  interactiveData: any
}

export function Product({ interactiveData }: ProductProps) {
  const productId = interactiveData.product_retailer_id || ''
  const bodyText = interactiveData.body_text || ''
  const footerText = interactiveData.footer_text || ''

  return (
    <div
      className="max-w-sm min-w-0"
      style={{ fontFamily: 'var(--wn-font)' }}
      data-testid="inbox-product-card"
    >
      <div className="flex items-start gap-2.5 pb-2.5 border-b border-[#edf1f7]">
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <Package className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="truncate"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}
          >
            Product
          </div>
          {productId && (
            <div
              className="truncate mt-0.5"
              style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
            >
              ID: {productId}
            </div>
          )}
        </div>
      </div>

      {bodyText && (
        <div
          className="mt-2.5 break-words whitespace-pre-wrap"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 500, color: '#101828' }}
          data-testid="inbox-product-body"
        >
          {bodyText}
        </div>
      )}

      {footerText && (
        <div
          className="mt-2 break-words"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
        >
          {footerText}
        </div>
      )}

      <div className="mt-3 pt-2.5 border-t border-[#edf1f7]">
        <button
          type="button"
          className="w-full rounded-[8px] py-2 px-4 transition-opacity hover:opacity-90"
          style={{
            background: '#1EB677',
            color: '#FFFFFF',
            fontFamily: 'var(--wn-font)',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          View product
        </button>
      </div>
    </div>
  )
}
